import React from 'react';
import Metrics from '@spotahome/soyuz-metrics';

import { Button } from '@spotahome/ui-library';
import { trans } from '@spotahome/soyuz/client';

import FavoritesPig from '../../../common/components/icons/FavoritesPig';

import './EmptyFavorites.scss';

const handleGoBackToSearch = () => {
  Metrics.ga.sendEvent(
    'My favorites',
    'go to home page button',
    'click button'
  );
};

const EmptyFavoritesNotLogged = () => (
  <div className="empty-favorites" id="no-results">
    <div className="empty-favorites__wrapper">
      <FavoritesPig />
      <p className="empty-favorites__text">
        {trans('favorites.message.will_appear')}
      </p>
    </div>
    <div className="empty-favorites__button-container">
      <Button
        className="ga-favorites-page-account-link"
        href="/"
        onClick={() => handleGoBackToSearch}
      >
        {trans('favorites.message.continue_searching')}
      </Button>
    </div>
  </div>
);

export default EmptyFavoritesNotLogged;
